import { useTranslation } from 'react-i18next'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

import { QuotesView } from './quotesView.types'

type QuotesViewsDropdownProps = {
  quotesView: QuotesView
  setQuotesView: (value: QuotesView) => void
}

const QuotesViewsDropdown: React.FC<QuotesViewsDropdownProps> = ({
  quotesView,
  setQuotesView,
}) => {
  const { t } = useTranslation()

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuotesView(event.target.value as QuotesView)
  }

  return (
    <div className="flex w-full flex-wrap items-center justify-center gap-3 md:justify-end">
      <div className="whitespace-nowrap font-sans text-neutral-500">
        { t('quotes.filters.sortBy') }
      </div>

      <TextField
        value={quotesView}
        onChange={onChange}
        size="small"
        select
      >
        <MenuItem
          value={QuotesView.cheapest}
        >
          <div className="font-sans text-sm">
            { t('quotes.filters.views.cheapest') }
          </div>
        </MenuItem>

        <MenuItem
          value={QuotesView.best}
        >
          <div className="font-sans text-sm">
            { t('quotes.filters.views.best') }
          </div>
        </MenuItem>

        <MenuItem
          value={QuotesView.bestRated}
        >
          <div className="font-sans text-sm">
            { t('quotes.filters.views.bestRated') }
          </div>
        </MenuItem>
      </TextField>
    </div>
  )
}

export default QuotesViewsDropdown
